<div class="blade-wrapper">
  <div class="blade-header">
    <div  class="blade-tools">
        <app-toolbar [toolbar]="toolbar">
            <ng-template 
              toolbarToolDef="test" let-tool>
              <ng-container  *ngIf="tool.hasButtonsToShow">
              <button mat-button
                      data-cy="button"
                      class="datex-button"
                      [disabled]="tool.control.readOnly || tool.control.disabled"
                      [ngStyle]="tool.control.styles.style"
                      [ngClass]="tool.control.styles.classes"
                      [matTooltip]="tool.control.tooltip"
                      matTooltipClass="datex-control-tooltip"
                      (click)="on_test_clicked($event)"
                      >
                <div class="button-label">
                  <ng-container *ngIf="tool.control.icon === 'datex-default-spinner'; else showIcon">
                    <div class="button-icon">
                      <i data-cy="button-icon" class="datex-default-spinner"></i>
                    </div>
                  </ng-container>
                  <ng-template #showIcon>
                    <div class="button-icon">
                      <i data-cy="button-icon" class="icon {{tool.control.icon}}"></i>
                    </div>
                  </ng-template>
                  <div data-cy="button-label" class="button-text">{{tool.control.label}}</div>
                </div>
              
              </button>
              </ng-container>
            </ng-template>
        </app-toolbar>
    </div>
    <ng-content></ng-content>
  </div>
  <div class="blade-content">
    <div class="datex-form">
      <ng-container *ngIf="initialized ">
        <div [formGroup]="formGroup"
             class="formdata">
                <div data-cy="fieldset-id-newGroup1"
                     *ngIf="!fieldsets.newGroup1.hidden && !fieldsets.newGroup1.removed"
                     class="fieldset-container">
                  <div class="fieldsetsContainer"
                       [ngClass]="{'collapsible': fieldsets.newGroup1.collapsible }">
                    <div *ngIf="!fieldsets.newGroup1.hideTitle"
                         data-cy="fieldset-title"
                         class="fieldsetsTitle"
                         (click)="fieldsets.newGroup1.toggle()">
                      <span class="fieldsetsTitle-text">
                      {{fieldsets.newGroup1.label}}
                      </span>
                      <i data-cy="fieldset-toggle"
                         *ngIf="fieldsets.newGroup1.collapsible"
                         class="icon"
                         [ngClass]="{'icon-ic_fluent_chevron_down_20_filled': !fieldsets.newGroup1.expanded, 'icon-ic_fluent_chevron_up_20_filled': fieldsets.newGroup1.expanded }"></i>
                    </div>
                    <div data-cy="fieldset-group"
                         *ngIf="fieldsets.newGroup1.expanded"
                         class="fieldsetsGroup">
                      <div data-cy="field-id-taskId" *ngIf="!fields.taskId.hidden && !fields.taskId.removed" 
                            class="field-container standard {{fields.taskId.invalid ? 'invalid' : ''}} {{fields.taskId.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.taskId.styles.style"
                            [ngClass]="fields.taskId.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.taskId.label + (fields.taskId.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.taskId.label}}<span *ngIf="fields.taskId.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <input data-cy="numberBox" formControlName="taskId"
                                matInput
                                numberBox
                                [format]="fields.taskId.control.format"
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-numberbox {{ (fields.taskId.control.readOnly || fields.taskId.control.disabled) ? 'readonly ' : ''}}"
                                placeholder="{{fields.taskId.control.placeholder}}"
                                [ngStyle]="fields.taskId.control.styles.style"
                                [ngClass]="fields.taskId.control.styles.classes"
                                [matTooltip]="fields.taskId.control.tooltip"
                                matTooltipClass="datex-control-tooltip">
                        <ng-container *ngIf="fields.taskId.invalid">
                          <ng-container *ngFor="let error of fields.taskId.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-orderLineNumber" *ngIf="!fields.orderLineNumber.hidden && !fields.orderLineNumber.removed" 
                            class="field-container standard {{fields.orderLineNumber.invalid ? 'invalid' : ''}} {{fields.orderLineNumber.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.orderLineNumber.styles.style"
                            [ngClass]="fields.orderLineNumber.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.orderLineNumber.label + (fields.orderLineNumber.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.orderLineNumber.label}}<span *ngIf="fields.orderLineNumber.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <input data-cy="numberBox" formControlName="orderLineNumber"
                                matInput
                                numberBox
                                [format]="fields.orderLineNumber.control.format"
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-numberbox {{ (fields.orderLineNumber.control.readOnly || fields.orderLineNumber.control.disabled) ? 'readonly ' : ''}}"
                                placeholder="{{fields.orderLineNumber.control.placeholder}}"
                                [ngStyle]="fields.orderLineNumber.control.styles.style"
                                [ngClass]="fields.orderLineNumber.control.styles.classes"
                                [matTooltip]="fields.orderLineNumber.control.tooltip"
                                matTooltipClass="datex-control-tooltip">
                        <ng-container *ngIf="fields.orderLineNumber.invalid">
                          <ng-container *ngFor="let error of fields.orderLineNumber.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>            </div>
        
                    <div class="fieldset-details" *ngIf="!fieldsets.newGroup1.expanded">
        
        
                    </div>
                  </div>
                </div>
              </div>
      </ng-container>

    </div>
  </div>
</div>